<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-04-03 08:37:38
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-07-07 16:28:46
 * @Description: 泵送费用
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/pumpingCostsEnd.vue
-->
<template>
  <div>
    <div style="display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 0; padding-right: 10px">
      <el-button v-if="!isLook" icon="el-icon-plus" size="small" class="bottom_all" style="margin-left: 0" @click="addCopy()">泵送复用</el-button>
      <el-button v-if="!isLook" icon="el-icon-plus" size="small" class="bottom_all" style="margin-left: 0" @click="add()">添加泵送</el-button>
    </div>
    <div>
      <el-table v-loading="tableLoading" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="tableData.filter(v => v.operate != 0)" tooltip-effect="dark">
        <el-table-column v-for="(item, index) in table" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center" :fixed="item.label == '操作' ? 'right' : false">
          <template slot-scope="scope">
            <span v-if="item.label == '操作'">
              <el-button v-if="!isLook" class="bottom_one" size="mini" @click="open(scope.row)"> 调价 </el-button>
              <el-button class="bottom_one" size="mini" @click="seeInfo(scope.row)"> 查看记录 </el-button>
              <el-button v-if="!isLook" class="bottom_two" size="mini" @click="deleteFun(scope.row, scope.$index)"> 删除 </el-button>
            </span>
            <span v-else-if="item.label == '含税单价（元/m³）'">
              <el-input v-model="scope.row.priceIncludinTax" :disabled="isLook" type="Number" style="width: 200px" @blur="scope.row.priceExcludingTax = ((scope.row.priceIncludinTax * 1) / (1 + (taxRate * 1 == 1 ? 0.03 : 0.13))).toFixed(2)" @mousewheel.native.prevent>
              </el-input>
            </span>
            <!-- <span v-else-if="item.label == '不含税单价（元/m³）'">
                            <span>{{scope.row.priceExcludingTax || '0.00'}}</span>
                        </span> -->
            <span v-else-if="item.label == '泵机类型'">
              <el-select v-model="scope.row.costsPumps" :disabled="isLook" value-key="pumpName" multiple placeholder="请选择">
                <el-option v-for="item in pumpList" :key="item.pumpName" :label="item.pumpName" :value="item"></el-option>
              </el-select>
            </span>
            <span v-else>{{ scope.row[item.prop] || "*" }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; margin-top: 10px">
        <div>补差方式：</div>
        <!-- <el-select v-model="costFromData.type" placeholder="请选择">
                    <el-option v-for="item in dataTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select> -->
      </div>
    </div>
    <div style="margin-top: 10px">
      <span>单次泵送量不足</span>
      <el-input
        v-model="costFromData.square"
        v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
        :disabled="isLook"
        style="width: 160px; margin: 0 20px"
        placeholder="请输入"
        type="Number" @mousewheel.native.prevent
      ></el-input>
      <span>m³，按</span>
      <el-input
        v-model="costFromData.unitPrice"
        v-input-limit="value => (String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/) ? String(value || '').match(/\d{1,6}(\.\d{1,2}|\.)?/)[0] : '')"
        :disabled="isLook"
        style="width: 160px; margin: 0 20px"
        placeholder="请输入"
        type="Number" @mousewheel.native.prevent
      >
      </el-input>
      <span>m³计。</span>
    </div>
    <!-- 泵送复用 -->
    <el-dialog :visible.sync="copyDialogVisible" width="500px" :close-on-click-modal="false" title="泵送复用" append-to-body>
        <div class="dialoginfo">
          <el-form :inline="true" label-width="120px">
            <el-form-item label="价格复用工程:">
              <el-select v-model="copyEngineeringId" placeholder="请选择" filterable style="width: 250px;">
                <el-option 
                  v-for="item in engineeringList" 
                  :key="item.ID" 
                  :label="item.NAME" 
                  :value="item.ID"> 
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="copyDialogVisible = false">取 消</el-button>
          <el-button class="bottom_all" style="margin-left: 24px" @click="confirmCopy()">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryPumpList, queryPumpCost, savePumpCost,queryResordEngineeringList } from "@/api/internetSales/engineeringControl.js";
export default {
  props: {
    engineeringId: {
      type: String,
      default: "",
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    taxRate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableParam: {
        page: 1,
        pageSize: 5,
        engineeringId: "",
      },
      table: [
        { label: "泵机类型", width: "auto", prop: "", status: true },
        { label: "含税单价（元/m³）", width: "auto", prop: "priceIncludinTax", status: true },
        // { label: "不含税单价（元/m³）", width: "120", prop: "priceExcludingTax", status: true },
        { label: "最新调整价格（元/m）", width: "120", prop: "latestAdjustmentsPrice", status: true },
        { label: "操作", width: "auto", prop: "", status: true },
      ],
      tableData: [],
      costFromData: {
        dataType: 1,
        type: 1,
        unitPrice: "",
        square: "",
        engineeringid: "",
      },
      // 补差类型
      dataTypeOptions: [
        { value: 1, label: "方补" },
        { value: 2, label: "车补" },
      ],
      pumpList: [],
      // 新增弹窗及下拉框所需的数据变量
      copyDialogVisible: false,
      copyEngineeringId: "",
      engineeringList: [],
    };
  },
  mounted() {
    
  },
  methods: {
    queryPumpList(){
      queryPumpList({ engId: this.engineeringId }).then(res => {
      if (res.code == 1001) {
        this.pumpList = [];
        res.data.forEach(item => {
            let data = {
              pumpId: item.id,
              pumpName: item.name,
            };
            this.pumpList.push(data);
        });
        console.log(this.pumpList);
      }
    });
    },
    
    savePumpCost() {
      this.costFromData.dataType = 1;
      this.costFromData.engineeringid = this.engineeringId;
      let type = false;
      this.tableData.forEach(item => {
        if (!item.costsPumps) {
          type = true;
        }
      });
      if (type) {
        this.$message.warning("泵机类型不允许为空!");
        return;
      }
      let data = {
        costs: this.tableData,
        transportation: this.costFromData,
      };
      savePumpCost(data).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功！");
          this.getData();
        }
      });
    },
    getData() {
      queryPumpCost({ engId: this.engineeringId }).then(res => {
        if (res.code == 1001) {
          res.data.costs.forEach(item => {
            item.operate = 1;
          });
          this.tableData = res.data.costs;
          this.costFromData = res.data.transportation || this.$options.data().costFromData;
        }
      });
    },
    // 3. 实现打开复用弹窗并请求工程列表
    addCopy() {
      this.copyDialogVisible = true;
      this.copyEngineeringId = ""; // 重置选择
      this.getEngineeringList();
    },
    // 获取工程列表
    getEngineeringList() {
      let params = {
        engineeringId: this.engineeringId
      };
      queryResordEngineeringList(params).then(res => {
        if (res.code == 1001) {
          this.engineeringList = res.data || [];
        }
      });
    },
    // 4. 实现点击确定按钮
    confirmCopy() {
      if (!this.copyEngineeringId) {
        this.$message.warning("请选择复用工程!");
        return;
      }
      // 根据选中的工程ID查询其泵送费用
      queryPumpCost({ engId: this.copyEngineeringId }).then(res => {
        if (res.code == 1001 && res.data && res.data.costs) {
          let copyData = res.data.costs;
          if (copyData.length === 0) {
            this.$message.warning("该工程暂无泵送费用数据可复用！");
            return;
          }
          // 将拉取到的数据追加到当前表格，并将 operate 设为 2 (新增状态)，清空原有 ID
          copyData.forEach(item => {
            let newItem = {
               ...item,
               id: null, // 清空ID，作为新数据
               engineeringid: this.engineeringId, // 绑定到当前工程
               operate: 2 // 状态置为添加
            };
            this.tableData.push(newItem);
          });
          
          this.$message.success("复用成功，请检查表格并点击保存！");
          this.copyDialogVisible = false;
        } else {
          this.$message.error("获取复用数据失败");
        }
      });
    },
    add() {
      let params = {
        costsPumps: [],
        engineeringid: this.engineeringId,
        priceExcludingTax: 0,
        priceIncludinTax: 0,
        operate: 2,
      };
      this.tableData.push(params);
    },
    open(val) {
      this.$emit("pumpingCostsSet", "dialog2", val);
    },
    seeInfo(val) {
      this.$emit("pumpingCostsNote", "dialog4", val);
    },
    deleteFun(val, index) {
      if (val.id) {
        val.operate = 0;
      } else {
        this.tableData.splice(index, 1);
      }
    },
    queryResordPageFun() {
      this.tableParam.engineeringId = this.engineeringId;
      // queryResordPage(this.tableParam).then(res=>{
      //     if (res.code == 1001 && res.data) {
      //         this.total = res.data.totalRows
      //         this.tableData = res.data.data
      //     }
      // })
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.queryResordPageFun();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
